export const categories = [
  {
    slug: 'qinzi-jiaoyu',
    name: '亲子教育情景',
    description: '家庭亲子互动与教育相关视频合集，记录温馨有爱的家庭教育时刻',
    icon: 'ri-parent-line',
    articleCount: 8,
  },
  {
    slug: 'yingshi-pianduan',
    name: '影视片段赏析',
    description: '经典影视作品中的精彩片段合集，回味荧幕中的经典瞬间',
    icon: 'ri-film-line',
    articleCount: 6,
  },
  {
    slug: 'gaoxiao-duanpian',
    name: '搞笑整蛊短片',
    description: '轻松幽默的搞笑视频与整蛊短片精选，带来欢乐好心情',
    icon: 'ri-emotion-laugh-line',
    articleCount: 7,
  },
  {
    slug: 'lishi-wenhua',
    name: '历史文化探究',
    description: '古今中外历史文化相关的视频内容，探寻背后的故事与渊源',
    icon: 'ri-history-line',
    articleCount: 5,
  },
  {
    slug: 'dongman-youxi',
    name: '动漫游戏集锦',
    description: '热门动漫与游戏中的经典桥段合集，二次元爱好者的视听盛宴',
    icon: 'ri-gamepad-line',
    articleCount: 6,
  },
  {
    slug: 'shehui-redian',
    name: '社会热点评论',
    description: '聚焦当下社会热点话题的视频评论与深度解读',
    icon: 'ri-fire-line',
    articleCount: 5,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};